import React, { useEffect, useMemo } from 'react';
import { Badge, Button, message, Skeleton, Space, Typography } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { AtbdTopDropdwon } from './auth-info-style';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import useApiFetch from '../../../hooks/useApiFetch';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../context/auth.context';
import qs from 'qs';
import moment from 'moment-timezone';
import { socketClient } from '../../../utility/SocketClient';
import { createGlobalStyle } from 'styled-components';

const NotificationMobileStyles = createGlobalStyle`
    @media only screen and (max-width: 575px) {
        .notification-mobile-popover {
            left: 12px !important;
            width: calc(100vw - 24px) !important;
            max-width: calc(100vw - 24px) !important;
        }

        .notification-mobile-popover .ant-popover-content,
        .notification-mobile-popover .ant-popover-inner,
        .notification-mobile-popover .atbd-top-dropdwon {
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box;
        }

        .notification-mobile-popover .ant-popover-arrow {
            left: var(--notification-arrow-left, 50%) !important;
            right: auto !important;
        }

        .notification-mobile-popover .atbd-top-dropdwon__content,
        .notification-mobile-popover .notification-content,
        .notification-mobile-popover .notification-text {
            min-width: 0;
        }

        .notification-mobile-popover .notification-text .ant-typography {
            overflow-wrap: anywhere;
        }

        .notification-mobile-popover .notification-text > div {
            flex-wrap: wrap;
            gap: 4px 12px;
        }

        .notification-mobile-popover .notification-text > div p {
            margin-left: 0 !important;
        }

        .notification-mobile-popover .notification-status {
            flex: 0 0 30px;
        }
    }
`;

function NotificationBox() {
    function renderThumb({ style, ...props }) {
        const thumbStyle = {
            borderRadius: 6,
            backgroundColor: '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
    }
    const [totalNotifications, setTotalNotifications] = React.useState(0);
    const notificationTriggerRef = React.useRef(null);
    const history = useHistory();
    const { apiClient } = useAuth();

    const {
        data: notifications,
        refetch: refetchNotifications,
        loading: loadingNotifications,
        setData: setNotifications,
    } = useApiFetch(`/api/org-users/me/notifications`, (data) => {
        setTotalNotifications(data?.meta?.total);
        return data.data;
    });

    useEffect(() => {
        const onNotification = async (data) => {
            const parsedData = JSON.parse(data);
            setNotifications((prevNotifications) => [parsedData, ...prevNotifications]);
            setTotalNotifications((prevTotal) => prevTotal + 1);
            // let icon = '';
            // if (parsedData.category === 'contact_messaged') {
            //     icon = <FeatherIcon icon="message-circle" size={16} />;
            // }
            // if (parsedData.category === 'request_callback') {
            //     icon = <FeatherIcon icon="phone-call" size={16} />;
            // }
            // if (parsedData.category === 'general') {
            //     icon = <FeatherIcon icon="bell" size={16} />;
            // }
        };

        socketClient.on('org-user-notification', onNotification);
        return () => {
            socketClient.removeListener('org-user-notification', onNotification);
        };
    }, []);

    const alignMobileArrow = React.useCallback(() => {
        if (!window.matchMedia('(max-width: 575px)').matches) return;

        const correctArrowPosition = () => {
            const popover = document.querySelector('.notification-mobile-popover');
            const trigger = notificationTriggerRef.current?.querySelector('.head-example');
            const arrow = popover?.querySelector('.ant-popover-arrow');
            if (!popover || !trigger || !arrow) return;

            const triggerRect = trigger.getBoundingClientRect();
            const arrowRect = arrow.getBoundingClientRect();
            const correction =
                triggerRect.left + triggerRect.width / 2 - (arrowRect.left + arrowRect.width / 2);
            const arrowLeft = arrow.offsetLeft + correction;
            popover.style.setProperty('--notification-arrow-left', `${arrowLeft}px`);
        };

        // The popover library can apply a final overflow adjustment after the
        // opening frame, so correct both before and after that adjustment.
        window.requestAnimationFrame(() => {
            correctArrowPosition();
            window.requestAnimationFrame(correctArrowPosition);
        });
        window.setTimeout(() => {
            correctArrowPosition();
        }, 150);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', alignMobileArrow);
        return () => window.removeEventListener('resize', alignMobileArrow);
    }, [alignMobileArrow]);

    const renderTrackVertical = () => {
        const thumbStyle = {
            position: 'absolute',
            width: '6px',
            transition: 'opacity 200ms ease 0s',
            opacity: 0,
            right: '2px',
            bottom: '2px',
            top: '2px',
            borderRadius: '3px',
        };
        return <div className="hello" style={thumbStyle} />;
    };

    function renderView({ style, ...props }) {
        const customStyle = {
            marginRight: '-17px',
        };
        return <div {...props} style={{ ...style, ...customStyle }} />;
    }

    renderThumb.propTypes = {
        style: PropTypes.shape(PropTypes.object),
    };

    renderView.propTypes = {
        style: PropTypes.shape(PropTypes.object),
    };

    const onNotificationClick = (notification) => {
        const hostUrl = window.location.origin;
        // console.log('notification', notification);
        // return;
        if (notification.ctaLink.includes(hostUrl)) {
            const queryParams = new URLSearchParams(notification.ctaLink.split('?')[1]);
            const query = queryParams.toString();
            const path = notification.ctaLink.replace(hostUrl, '').split('?')[0];
            history.push({
                pathname: path,
                search: query,
            });
        } else if (notification?.ctaLink?.startsWith('http')) {
            window.open(notification.ctaLink, '_blank');
        } else {
            history.push(notification.ctaLink);
        }
    };

    const deleteNotification = async (notification) => {
        const allNotifications = [...notifications];
        try {
            setNotifications((prevNotifications) => prevNotifications.filter((n) => n.id !== notification.id));
            setTotalNotifications((prevTotal) => Math.max(0, prevTotal - 1));
            await apiClient.delete(
                `/api/org-users/me/notifications?${qs.stringify(
                    { ids: [notification.id] },
                    {
                        encodeValuesOnly: true,
                    },
                )}`,
            );
        } catch (error) {
            message.error('Failed to delete notification');
            setNotifications(allNotifications);
            setTotalNotifications((prevTotal) => Math.max(0, prevTotal + 1));
        }
    };

    const content = useMemo(
        () =>
            loadingNotifications ? (
                <AtbdTopDropdwon className="atbd-top-dropdwon">
                    <Skeleton title paragraph={{ rows: 1, width: '100%' }} active />
                    <Skeleton title paragraph={{ rows: 1, width: '100%' }} active />
                    <Skeleton title paragraph={{ rows: 1, width: '100%' }} active />
                </AtbdTopDropdwon>
            ) : (
                <AtbdTopDropdwon
                    style={{
                        width: '450px',
                    }}
                    className="atbd-top-dropdwon"
                >
                    <Heading as="h5" className="atbd-top-dropdwon__title">
                        <span className="title-text">Notifications</span>
                        <Badge
                            className="badge-success"
                            count={totalNotifications > 100 ? '100+' : totalNotifications}
                        />
                    </Heading>
                    <Scrollbars
                        autoHeight
                        renderThumbVertical={renderThumb}
                        renderView={renderView}
                        renderTrackVertical={renderTrackVertical}
                    >
                        <ul
                            className="atbd-top-dropdwon__nav notification-list"
                            style={{ height: 'auto', marginTop: '12px' }}
                        >
                            {notifications.map((notification) => {
                                return (
                                    <li key={notification.id}>
                                        <div className="atbd-top-dropdwon__content notifications">
                                            {notification.category === 'contact_messaged' && (
                                                <div className={`notification-icon bg-${notification.type}`}>
                                                    <FeatherIcon icon="message-circle" />
                                                </div>
                                            )}
                                            {notification.category === 'general' && (
                                                <div className={`notification-icon bg-${notification.type}`}>
                                                    <FeatherIcon icon="bell" />
                                                </div>
                                            )}
                                            {notification.category === 'request_callback' && (
                                                <div className={`notification-icon bg-${notification.type}`}>
                                                    <FeatherIcon
                                                        // icon="phone-call"
                                                        icon="phone-forwarded"
                                                    />
                                                </div>
                                            )}
                                            <div
                                                className="notification-content d-flex"
                                                style={{ alignItems: 'start', gap: '4px' }}
                                            >
                                                <div className="notification-text" style={{ width: '100%' }}>
                                                    <Typography.Text strong type="secondary">
                                                        {notification.title}
                                                    </Typography.Text>
                                                    <br />
                                                    <Typography.Text type="secondary">
                                                        {notification.message}
                                                    </Typography.Text>
                                                    <br />
                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                        {notification.ctaText && notification.ctaLink && (
                                                            <p
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#1890ff',
                                                                    textDecoration: 'underline',
                                                                }}
                                                                onClick={() => onNotificationClick(notification)}
                                                            >
                                                                <span>{notification.ctaText}</span>
                                                            </p>
                                                        )}
                                                        <p style={{ marginLeft: 'auto' }}>
                                                            {moment(notification.createdAt).fromNow()}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="notification-status"
                                                    style={{ cursor: 'pointer', width: '30px', height: 'fit-content' }}
                                                    onClick={() => deleteNotification(notification)}
                                                >
                                                    <FeatherIcon icon="x" size={18} />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </Scrollbars>
                    {/* <Link className="btn-seeAll" to="#">
                        See all incoming activity
                    </Link> */}
                </AtbdTopDropdwon>
            ),
        [notifications, totalNotifications],
    );

    return (
        <div className="notification" ref={notificationTriggerRef}>
            <NotificationMobileStyles />
            <Popover
                action="click"
                content={content}
                overlayClassName="notification-mobile-popover"
                placement="bottomLeft"
                onVisibleChange={(visible) => {
                    if (!visible) return;
                    alignMobileArrow();
                }}
            >
                <Badge dot={!loadingNotifications && totalNotifications > 0} offset={[-8, -5]}>
                    <Link to="#" className="head-example">
                        <FeatherIcon icon="bell" size={20} />
                    </Link>
                </Badge>
            </Popover>
        </div>
    );
}

export default NotificationBox;
